import React from 'react';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import TR from './../../Trans';

function ArrowButton(props) {

  const renderButton = () => { 
    if(props.isLeft){
      return <IconButton color="white" component="label" onClick={props.onScrollClick}>
      <ChevronLeftIcon />
    </IconButton>
    }else{
      return <IconButton color="white" component="label" onClick={props.onScrollClick}>
      <ChevronRightIcon />
    </IconButton>
    }
  }

  return (
    <div className={props.className} onClick={props.onScrollClick}>
      {renderButton()}
    </div>
  );
}

export default ArrowButton;